import { AppIcon } from './AppIcon.tsx';

/** Eigenschaften der Sterneanzeige. */
export interface StarsProps {
  /** Angezeigter Wert, zum Beispiel 4,3. */
  readonly value: number | null;
  /** Anzahl der Bewertungen, wird als Zusatz angezeigt. */
  readonly count?: number;
  /** Lässt die Sterne anklicken. */
  readonly editable?: boolean;
  /** Wird beim Anklicken mit der Anzahl der Sterne aufgerufen. */
  readonly onChange?: (stars: number) => void;
  readonly size?: number;
}

/**
 * Sterne von 1 bis 5. Angebrochene Werte werden halb gefüllt dargestellt,
 * damit ein Durchschnitt wie 4,3 erkennbar bleibt.
 */
export function Stars({ value, count, editable = false, onChange, size = 18 }: StarsProps) {
  const filled = value ?? 0;

  return (
    <span className="inline-flex items-center gap-1" role="img" aria-label={`${filled} von 5 Sternen`}>
      {[1, 2, 3, 4, 5].map((star) => {
        const isFull = filled >= star;
        const isHalf = !isFull && filled > star - 1;
        const className = isFull ? 'text-accent' : isHalf ? 'text-accent/50' : 'text-border-subtle';
        if (!editable) {
          return <AppIcon key={star} name="star" size={size} className={className} />;
        }
        return (
          <button
            key={star}
            type="button"
            aria-label={`${star} Sterne geben`}
            onClick={() => onChange?.(star)}
            className={`${className} p-0.5`}
          >
            <AppIcon name="star" size={size} />
          </button>
        );
      })}
      {count === undefined ? null : (
        <span className="ml-1 text-xs text-content-muted">
          {value === null ? '–' : new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 }).format(value)}
          {count > 0 ? ` (${count})` : ''}
        </span>
      )}
    </span>
  );
}
